import { useTranslation } from "react-i18next";
import { LogoutCurve } from "iconsax-react";
import { Avatar, Dropdown, DropdownItem } from "@/shared/ui";
import { AppearanceSection } from "@/features/settings";
import { RoleSwitcherRow } from "@/features/demo";
import { runtimeConfig } from "@/shared/config/runtime";
import OrganizationCard from "../OrganizationCard";
import ProfileMenuHeader from "./ProfileMenuHeader";
import { useProfileMenu } from "./useProfileMenu";

export default function ProfileMenu() {
  const { t } = useTranslation("Sidebar");
  const profileMenu = useProfileMenu();

  return (
    <Dropdown
      open={profileMenu.isOpen}
      onClose={profileMenu.closeMenu}
      align="right"
      direction="bottom"
      width="w-[340px]"
      className="rounded-4xl! p-4!">
      <button
        type="button"
        title={t("profileMenu")}
        aria-label={t("profileMenu")}
        aria-expanded={profileMenu.isOpen}
        disabled={profileMenu.isLogoutLoading}
        onClick={profileMenu.toggleMenu}
        className="shrink-0 disabled:opacity-60 cursor-pointer">
        <Avatar name={profileMenu.displayName} size={40} textClassName="text-sm" />
      </button>

      <ProfileMenuHeader name={profileMenu.displayName} email={profileMenu.email} onClick={profileMenu.goToProfile} />

      <OrganizationCard clickable={profileMenu.isChief} onClick={profileMenu.goToOrganization} />

      <span className="block h-[0.5px] my-1 surface-app-stroke-fill opacity-50" />

      {(runtimeConfig.isDemo || runtimeConfig.useMockApi) && <RoleSwitcherRow />}

      <AppearanceSection />

      <span className="block h-[0.5px] my-1 surface-app-stroke-fill opacity-50" />

      <DropdownItem onClick={profileMenu.handleLogout} disabled={profileMenu.isLogoutLoading} className="px-0!">
        <LogoutCurve size={18} color="currentColor" className="content-action-negative" />
        <span className="content-action-negative">
          {profileMenu.isLogoutLoading ? t("logout.loading") : t("logout")}
        </span>
      </DropdownItem>
    </Dropdown>
  );
}

